<template>
  <div class="back-btn" @click="goBack()" :style="getIcoOfBg('backbtn')"></div>
</template>

<script lang="ts" setup>
import { onBeforeUnmount, onMounted, computed } from 'vue';
import { useRouter } from 'vue-router';
import { getIcoOfBg } from '@config/siteConfig';
import { useBaseStore } from '@store/base';
const props = defineProps({
  moduleName: {
    default: '',
  },
});
const base = useBaseStore();
const router = useRouter();
const allModuleConfig = computed(() => {
  return base.moduleConfig;
});
const goBack = () => {
  clickButtonPoint({
    btnName: 'back',
    moduleName: props.moduleName,
  });
  if (window.history.state.back === null) {
    router.push({
      path: allModuleConfig.value[0].MODULE_PATH,
    });
    return;
  }
  router.go(-1);
};
</script>
<style scoped lang="scss">
@import '@assets/scss/dimen.scss';
@import '@assets/scss/mixin.scss';
.back-btn {
  position: absolute;
  left: 0;
  top: 0;
  width: 112px;
  height: 112px;
  cursor: pointer;
  z-index: 2;
  @include addTouchEffect();
}

@media only screen and (min-height: 640px) and (orientation: landscape) {
  .back-btn {
    width: calc(112px / $pcRate);
    height: calc(112px / $pcRate);
  }
}
</style>
